<template>
  <div class="activity-wrap">
    <app-header />
    <div class="banner">
      <img
        class="banner_two"
        src="../../assets/images/activity/activity202311113/banner3.png"
      />
      <img
        class="img_btn"
        src="../../assets/images/activity/activity202311113/btnImg.png"
      />
      <img
        class="img_text"
        src="../../assets/images/activity/activity202311113/text_img.png"
      />
      <p>活动时间:11.1-11.30</p>
      <img
        class="text_bm_box"
        src="../../assets/images/activity/activity202311113/text_bm.png"
      />
			<img class="logo_img" src="../../assets/images/activity/activity202311113/logo.png" />
    </div>
    <div class="nav_main">
      <div class="nav_one">
        <div class="ask_btn" @click="showPop">限量申请</div>
        <div class="buy_btn" @click="handlePurchase(1)">立即购买</div>
      </div>
      <div class="nav_two">
        <div class="ask_btn"  @click="showPop">限量申请</div>
        <div class="buy_btn" @click="handlePurchase(12)">立即购买</div>
      </div>
      <div class="nav_three">
        <div class="ask_btn"  @click="showPop">限量申请</div>
        <!-- <div class="buy_btn" @click="handlePurchase(12)">立即购买</div> -->
      </div>
    </div>
    <div class="text_content_main">
      <p class="top_text">了解详情请联系客服</p>
      <p class="header_box">活动规则:</p>
      <p class="text_min">1. 本次活动有效期为：2023年11月1日至11月30日；</p>
      <p class="text_min">
        2. 活动期间，成为大智慧VIP月卡的用户，即送20G定制银条一根；
      </p>
      <p class="text_min">
        3.
        成为大智慧VIP年卡的用户，即送100ML茅台一瓶或100G银条一根，二者任选其一；
      </p>
      <p class="text_min">
        4.
        成为大智慧VIP年卡PRO版的用户，即送500ML飞天茅台一瓶或8G定制金条一根，二者任选其一；
      </p>
      <p class="text_min">
        5.
        成为大智慧VIP的用户，软件权限需至少满30天才可兑换礼品，用户因任何原因导致退款或大智慧VIP权限被关闭的将不可兑换礼品；
      </p>
      <p class="text_min">6. 用户可至个人中心”我的礼券“下看到礼品权益；</p>
      <p class="text_min">
        7.
        所有实物奖励兑换时间为2024年1月1日—1月31日，期间未兑换领取的礼品券将失效；发货时间为2024年1月31日前；
      </p>
      <p class="text_min">
        8.
        如用户拒签/收取实物礼品或未及时签收等导致实物礼品未妥投，默认用户退回并放弃礼品。所有礼品均不可折现提取；
      </p>
      <p class="text_min">
        9.
        兑换时填写的信息请务必认真核对，如填写信息有误造成的损失本公司概不负责。
      </p>
      <p class="text_min">
        10.每个用户限领3份；礼品的20%个人所得税由大智慧进行缴纳，用户无需承担该费用，但需提交领取人的实名信息，以便大智慧进行税费缴纳，如因用户未提交真实的实名信息而造成的无法领取礼品，则示为放弃礼品。
      </p>
    </div>
    <div class="footer_text_main">
      <p>活动说明:</p>
      <p>
        1.
        如果下载、参与活动或领取礼品时时因网络异常无法正常继续下一步动作，请在网络正常后重试；系统维护、升级时可能会影响用户的领取状态，等待系统正常后再查询，大智慧不对网络异常、系统维护升级、黑客袭击及其他不可抗力因素造成的活动障碍承担相应责任；
      </p>
      <p>
        2.
        为保证活动有序进行，如用户存在违反法律法规及本活动规则的行为，侵犯第三人合法权益、扰乱系统、实施网络攻击、恶意套现、刷实物奖励、用机器模拟客户端作弊等，我们有权取消该用户的活动资格或取消、追回该用户通过活动所获得的礼品或权益；
      </p>
      <p>
        3.
        如果出现包括但不限于以下情形：供应商生产计划变化、系统故障、不可抗力等因素影响，用户所得礼品由于非本公司原因而导致的缺货情况下，会更换等价奖品或以其他有效方式向用户通知并提供解决方案。请用户在未收到礼品之前留意通知；
      </p>
    </div>
    <div class="footer">
      <p class="wrap">
        风险提示：本产品不涉及投资咨询及投资顾问服务，所展示信息不构成投资建议；数据基于历史，不代表未来趋势；<br />所有工具都有局限性，适合不同情况下的市场，仅供参考，请理性投资，控制风险，投资有风险，入市需谨慎。
      </p>
    </div>
    <!-- 弹框背景 -->
    <div class="pop_bg" v-if="showProblem || showNextDom"></div>
    <!-- 弹框 -->
    <div class="pop_problem_box" v-if="showProblem || showNextDom">
      <div class="content_main" v-if="showProblem">
        <div class="list_li" v-for="(item, index) in problemList" :key="index">
          <p>{{ item.title }}</p>
          <ul>
            <li
              :class="item.answer === itemList.type ? 'show_btn' : ''"
              v-for="(itemList, indexList) in item.list"
              :key="indexList"
              @click="handleCheckProblem(index, itemList)"
            >
              {{ itemList.text }}
            </li>
          </ul>
        </div>
        <img @click="close" src="../../assets/images/activity/activity202311113/close.png" />
        <div class="nextBtn" @click="handleNext">下一步 <div class="reminder_box" v-show="reminderShow">您尚有未回答的问题。</div></div>
      </div>

      <div class="content_main nextDom_main" v-if="showNextDom">
        <div class="top_text">请等待联系</div>
        <div class="center_main">
          <p>亲爱的用户,</p>
          <p>我们已经收到您的申请,客服人员将尽快联系您,请保持手机的畅通</p>
        </div>
        <p class="phone">咨询请致电021-20219999</p>
        <img @click="close" src="../../assets/images/activity/activity202311113/close.png" />
        <div class="certain_btn" @click="handleCertain">确定</div>
      </div>
    </div>
  </div>
</template>
  <script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
  components: {
    AppHeader,
  },
  data() {
    return {
      token: "",
      answers:[],
      problemList: [
        {
          question: 1339,
          title: "1.你是否投资过股票？",
          list: [
            { text: "是", type: "A" },
            { text: "否", type: "B" },
          ],
          answer: "",
        },
        {
          question: 1338,
          title: "2.你开通过创业板、科创版或者其他融资融券账户吗？",
          list: [
            { text: "已开通", type: "A" },
            { text: "未开通", type: "B" },
          ],
          answer: "",
        },
        {
          question: 1337,
          title: "3.你目前的操作资金规模有多大？",
          list: [
            { text: "1-30万", type: "A" },
            { text: "30-50万", type: "B" },
            { text: "50-100万", type: "C" },
            { text: "100万以上", type: "D" },
          ],
          answer: "",
        },
      ],
      showProblem: false,
      showNextDom: false,
			reminderShow: false,
    };
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  mounted() {},
  methods: {
    handleCheckProblem: function (index, item) {
      console.log(index, item);
      let that = this;
      that.$set(that.problemList[index], "answer", item.type);
    },
    handleNext: function () {
      let that = this;
      let arr = that.problemList;
      let next = arr.every((item) => {
        return item.answer !== "";
      });
			console.log(next)
      if (next) {
        // 显示下一个弹框\
        this.sendQuestionnaire()
      }else{
				this.reminderShow = true;
			}
    },
    handleCertain: function () {
			this.close();
    },
		close:function(){
			let that = this;
			that.showProblem = false;
      that.showNextDom = false;
      that.problemList.forEach((item,index)=>{
				that.$set(that.problemList[index], "answer", item);
			})
      
		},
		// 购买跳转
		handlePurchase:function(type){
			let url;
			switch (type) {
				case 1:
					url = url = this.$router.resolve({name: 'OrderConfirm335',params:{month: "1m"}});
					break;
				case 12:
					url = url = this.$router.resolve({name: 'OrderConfirm', params:{productId: 335,month: 12}});
					break;
				// case 12:
				// 	url = url = this.$router.resolve({name: 'OrderConfirm', params:{productId: 335,month: 12}});
					// break;
				default:
					break;
			}
      let {href} = url
			window.open(href);
		},
		showPop:function(){
      this.$post("/questionnaire/sendQuestionnaire")
        .then(response => {
          if (response.code === 0) {
            this.showProblem = true;
        }else if(response.code === 107){
          alert(response.msg)
        }
      })
		},
    sendQuestionnaire:function(){
      var params ={
        data : this.problemList
      }
      this.$post("/questionnaire/sendQuestionnaire",params)
        .then(response => {
          if (response.code === 0) {
            alert("保存申请问卷成功")
            this.showNextDom = true;
				    this.showProblem = false;
				    this.reminderShow = false;
          }else {
            alert(response.msg)
        }
      })
    }
  },
};
</script>
  <style lang="scss" scoped>
.activity-wrap {
  background: #a90000;
  background-image: -webkit-linear-gradient(
    top,
    #ab0001 0%,
    #a90000 50%,
    #a90000 100%
  );
  overflow: hidden;
  overflow: hidden;
  .banner {
    background: url("../../assets/images/activity/activity202311113/banner.png")
      no-repeat center top;
    background-size: 100% 532px;
    position: relative;
    height: 690px;
    text-align: center;
    padding-top: 50px;
    overflow: hidden;
    box-sizing: border-box;
    p {
      font-size: 26px;
      font-weight: normal;
      font-style: italic;
      font-stretch: normal;
      line-height: 32px;
      letter-spacing: 0px;
      color: #ffffff;
      position: absolute;
      bottom: 23px;
      left: 50%;
      transform: translate(-50%, 0);
    }
    .banner_two {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, 0);
    }
    .img_btn {
      position: absolute;
      top: 68px;
      left: 50%;
      transform: translate(-50%, 0);
      width: 208px;
      height: 42px;
    }
    .img_text {
      position: absolute;
      top: 125px;
      left: 50%;
      transform: translate(-50%, 0);
    }
    .text_bm_box {
      position: absolute;
      bottom: 70px;
      left: 50%;
      transform: translate(-50%, 0);
    }
		.logo_img{
			width: 138px;
			height: 43px;
			position: absolute;
			top: 28px;
			left: 20px;
		}
  }
  .nav_main {
    width: 1260px;
    margin: 0 auto;
    padding: 0 114px 36px 114px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .nav_one {
      width: 296px;
      height: 502px;
      background: url("../../assets/images/activity/activity202311113/nav_1.png")
        no-repeat center top;
      background-size: 100% 100%;
      padding: 340px 40px 23px 40px;
      box-sizing: border-box;
    }
    .nav_two {
      width: 330px;
      height: 502px;
      background: url("../../assets/images/activity/activity202311113/nav_21.png")
        no-repeat center top;
      background-size: 100% 100%;
      padding: 340px 40px 23px 40px;
      box-sizing: border-box;
    }
    .nav_three {
      width: 330px;
      height: 502px;
      background: url("../../assets/images/activity/activity202311113/nav_31.png")
        no-repeat center top;
      background-size: 100% 100%;
      padding: 340px 40px 23px 40px;
      box-sizing: border-box;
    }
    .ask_btn {
      width: 100%;
      height: 63px;
      background-image: linear-gradient(0deg, #7c0003 0%, #d90810 100%),
        linear-gradient(#a90000, #a90000);
      background-blend-mode: normal, normal;
      border-radius: 15px;
      color: #fff;
      font-size: 29px;
      line-height: 63px;
      text-align: center;
      cursor: pointer;
      margin-bottom: 12px;
    }
    .buy_btn {
      width: 100%;
      height: 63px;
      border: 1px solid #d90810;
      border-radius: 15px;
      color: #d90810;
      font-size: 29px;
      line-height: 63px;
      text-align: center;
      cursor: pointer;
    }
  }
  .text_content_main {
    width: 1260px;
    margin: 0 auto;
    padding: 0 114px;
    box-sizing: border-box;
    font-weight: normal;
    font-style: italic;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #ffffff;
    .top_text {
      font-size: 24px;
      line-height: 32px;
      text-align: right;
    }
    .header_box {
      font-size: 20px;
      margin-bottom: 6px;
    }
    .text_min {
      font-size: 16px;
      margin-bottom: 6px;
    }
  }
  .footer_text_main {
    width: 1260px;
    margin: 0 auto;
    padding: 0 114px 20px;
    box-sizing: border-box;
    color: #d17777;
    font-size: 13px;
    margin-top: 23px;
    p {
      &:first-child {
        margin-bottom: 4px;
      }
    }
  }
  .footer {
    background: #3f3f3f;
    text-align: center;
    padding: 20px 0 30px;
  }
  .footer p {
    font-size: 14px;
    color: #fff;
    opacity: 0.3;
    line-height: 2;
  }
  .pop_bg {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba($color: #000, $alpha: 0.3);
  }
  .pop_problem_box {
    width: 872px;
    background-color: #fff;
    border-radius: 15px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .content_main {
      width: 100%;
      height: 100%;
      padding: 55px;
      box-sizing: border-box;
      position: relative;
      .list_li {
        margin-bottom: 50px;
        &:last-child {
          margin: 0;
        }
        p {
          font-size: 26px;
          color: #303030;
          margin-bottom: 26px;
        }
        ul {
          li {
            display: inline-block;
            min-width: 173px;
            height: 77px;
            background-color: #f2f2f2;
            border-radius: 10px;
            margin-right: 17px;
            font-size: 26px;
            color: #444d83;
            text-align: center;
            line-height: 77px;
            cursor: pointer;
            &:last-child {
              margin: 0;
            }
            &.show_btn {
              background-image: linear-gradient(0deg, #376aee 1%, #4684ee 100%),
                linear-gradient(#8f99d6, #8f99d6);
              background-blend-mode: normal, normal;
              color: #fff;
            }
          }
        }
      }
      img {
        position: absolute;
        top: -40px;
        right: -40px;
        width: 40px;
        height: 40px;
        cursor: pointer;
      }
      .nextBtn {
        width: 173px;
        height: 60px;
        line-height: 60px;
        background-image: linear-gradient(0deg, #376aee 1%, #4684ee 100%),
          linear-gradient(#8f99d6, #8f99d6);
        background-blend-mode: normal, normal;
        color: #fff;
        cursor: pointer;
        font-size: 26px;
        text-align: center;
        border-radius: 10px;
				position: relative;
				.reminder_box{
					position: absolute;
					right: -300px;
					top: 0;
					color: red;
					font-size: 20px;
					width: 300px;
				}
      }
    }
    .nextDom_main {
      padding: 106px 190px 85px 190px;
      box-sizing: border-box;
      .top_text {
        font-size: 48px;
        color: #8f99d6;
        margin-bottom: 55px;
      }
      .center_main {
        font-size: 26px;
        line-height: 40px;
        letter-spacing: 1px;
        color: #3b3b3b;
        margin-bottom: 36px;
      }
      .phone {
        font-size: 24px;
        color: #b7b7b7;
      }
      .certain_btn {
        width: 100%;
        height: 92px;
        background-image: linear-gradient(0deg, #376aee 1%, #4684ee 100%),
          linear-gradient(#4f61d3, #4f61d3);
        background-blend-mode: normal, normal;
        border-radius: 10px;
				color: #FFF;
				text-align: center;
				line-height: 92px;
				font-size: 30px;
				margin-top: 80px;
				cursor: pointer;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/activity/activity202311113.vue